export const navLinks = [
  { label: 'HOME', href: '#home' },
  { label: 'WORKS', href: '#works' },
  { label: 'ACHIEVEMENTS', href: '#achievements' },
  { label: 'PROFILE', href: '#profile' },
  { label: 'CONTACT', href: '#contact' },
];

export const socialLinks = [
  { label: 'Instagram', href: 'https://www.instagram.com/ameri_iria?igsh=MTRxbmZkaW5tNXRocg%3D%3D&utm_source=qr', icon: 'ri-instagram-line' },
  { label: 'Spotify', href: 'https://open.spotify.com/playlist/4NIBk1d8MZ4wqHOHlNDYLF?si=00034c16fc63458e', icon: 'ri-spotify-fill' },
];

export const skills = [
  { name: 'Lyrics', percentage: 95 },
  { name: 'Composition', percentage: 95 },
  { name: 'Vocals', percentage: 90 },
  { name: 'Topline Writing', percentage: 88 },
  { name: 'Backing Vocals', percentage: 88 },
  { name: 'Vocal Production', percentage: 90 },
  { name: 'Vocal Direction', percentage: 92 },
  { name: 'BGM', percentage: 85 },
];

export const worksArtists = [
  {
    id: 1,
    title: 'Dancing In The Rain',
    artist: 'THE JET BOY BANGERZ',
    format: 'Single',
    releaseDate: '2024-01-24',
    label: 'SONY MUSIC',
    category: 'J-POP',
    description: 'オリコン週間シングルランキング1位獲得作品',
    image: 'https://storage.readdy-site.link/project_files/346f2ee0-d729-4568-8b32-aa7af4cc60d4/d37eed07-6517-40ce-aeb4-d104e661e36d_compressed_-2026-07-23-16.56.40.webp',
  },
  {
    id: 2,
    title: 'オーシャンビュー',
    artist: 'timelesz',
    format: 'Album',
    releaseDate: '2024-03-13',
    label: 'ユニバーサルミュージック',
    category: 'J-POP',
    description: '日本レコード協会プラチナ認定アルバム収録',
    image: 'https://storage.readdy-site.link/project_files/346f2ee0-d729-4568-8b32-aa7af4cc60d4/5db0c14a-e479-4f92-b58d-8926a349a982_compressed_-2026-07-23-18.40.04.webp',
  },
  {
    id: 3,
    title: 'REBEL HEART\nATTITUDE\nThank U',
    artist: 'IVE',
    format: 'Single',
    releaseDate: '2025-01-13',
    label: 'STARSHIP',
    category: 'K-POP',
    description: '韓国主要音楽チャート1位、日本レコード協会ゴールド認定',
    image: 'https://storage.readdy-site.link/project_files/346f2ee0-d729-4568-8b32-aa7af4cc60d4/05a1760a-6680-4aea-8e04-dbc11231f4de_compressed_-2026-07-23-17.53.23.webp',
  },
  {
    id: 11,
    title: 'give you',
    artist: 'M!lk',
    format: 'Single',
    releaseDate: '2024-11-20',
    label: 'Independent',
    category: 'Creator',
    description: 'Instagram Reels総再生数3,000万回突破',
    image: 'https://storage.readdy-site.link/project_files/346f2ee0-d729-4568-8b32-aa7af4cc60d4/fa6af3cf-ffe5-46b2-b7a0-1e34a6489176_compressed_-2026-07-23-17.57.20.webp',
  },
  {
    id: 5,
    title: 'formula in blue',
    artist: '劇場版「美少女戦士セーラームーン Eternal」Eternal Collection',
    format: 'Album',
    releaseDate: '2021-02-10',
    label: 'キングレコード',
    category: 'J-POP',
    description: '劇場版「美少女戦士セーラームーン Eternal」主題歌',
    image: 'https://storage.readdy-site.link/project_files/346f2ee0-d729-4568-8b32-aa7af4cc60d4/9bbb77ed-1a1c-4fd3-8709-2814f986cc32_compressed_-2026-07-23-16.54.16.webp',
  },
  {
    id: 6,
    title: 'Same Scent',
    artist: 'ONEUS',
    format: 'Single',
    releaseDate: '2022-09-05',
    label: 'RBW',
    category: 'K-POP',
    description: 'Japanese Version、SNS総再生数3,000万回超',
    image: 'https://storage.readdy-site.link/project_files/346f2ee0-d729-4568-8b32-aa7af4cc60d4/5f8295b0-825e-4c29-b45b-4f8c9378eb2c_compressed_-2026-07-23-18.57.39.webp',
  },
  {
    id: 7,
    title: 'ぷっちょへんざっ',
    artist: 'Mumeixxx',
    format: 'Single',
    releaseDate: '2024-06-12',
    label: 'Independent',
    category: 'Creator',
    description: 'TikTok総再生数7,000万回突破',
    image: 'https://storage.readdy-site.link/project_files/346f2ee0-d729-4568-8b32-aa7af4cc60d4/7e64503f-cd35-4e10-9055-03503777ba95_compressed_-2026-07-23-18.37.02.webp',
  },
  {
    id: 8,
    title: '指ペロ配布、ま？',
    artist: '吉田いをん',
    format: 'Single',
    releaseDate: '2024-08-21',
    label: 'Independent',
    category: 'Creator',
    description: 'TikTok総再生数3,000万回突破',
    image: 'https://storage.readdy-site.link/project_files/346f2ee0-d729-4568-8b32-aa7af4cc60d4/ed0d5465-1b0a-44bf-9e2a-447b2ad75f49_compressed_-2026-07-23-18.37.43.webp',
  },
  {
    id: 9,
    title: 'BEEP (Japan Edition)',
    artist: 'izna',
    format: 'Single',
    releaseDate: '2024-11-25',
    label: 'WAKEONE',
    category: 'K-POP',
    description: '韓国主要音楽チャート上位イン',
    image: 'https://storage.readdy-site.link/project_files/346f2ee0-d729-4568-8b32-aa7af4cc60d4/4130d0a7-a9ce-420e-9042-2a23eff32c37_compressed_-2026-07-23-19.07.48.webp',
  },
  {
    id: 10,
    title: 'ハピメモ',
    artist: '岡咲美保',
    format: 'Single',
    releaseDate: '2024-07-10',
    label: '日本コロムビア',
    category: 'J-POP',
    description: 'アニメタイアップ主題歌',
    image: 'https://storage.readdy-site.link/project_files/346f2ee0-d729-4568-8b32-aa7af4cc60d4/268ee117-2d36-4c08-8d01-6f353291ee26_compressed_-2026-07-23-18.39.21.webp',
  },
  {
    id: 4,
    title: 'ТІРІ-ТАР',
    artist: 'Kep1er',
    format: 'Single',
    releaseDate: '2024-11-01',
    label: 'WAKEONE',
    category: 'K-POP',
    description: '韓国主要音楽チャート1位、米Billboardメインチャート14位',
    image: 'https://storage.readdy-site.link/project_files/346f2ee0-d729-4568-8b32-aa7af4cc60d4/526d59fb-e411-4b4f-947d-3b8f27cec50c_compressed_-2026-07-23-18.48.17.webp',
  },
  {
    id: 12,
    title: 'Lollipop',
    artist: '蒼井翔太',
    format: 'Single',
    releaseDate: '2024-08-15',
    label: 'KING RECORDS',
    category: 'J-POP',
    description: 'オリコン週間シングルランキング5位',
    image: 'https://storage.readdy-site.link/project_files/346f2ee0-d729-4568-8b32-aa7af4cc60d4/2e033a0a-b10c-44c6-a3c2-fb174d36d68d_compressed_-2026-07-23-18.40.28.webp',
  },
];

export const achievements = [
  { label: 'IVE「REBEL HEART -Japanese ver.-」「ATTITUDE -Japanese ver.-」SNS総再生数', value: '各2.5億回超え' },
  { label: 'Kep1er「ТІРІ-ТАР (Japanese ver.)」SNS総再生数', value: '8,000万回超え' },
  { label: 'Mumeixxx「ぷっちょへんざっ」TikTok総再生数', value: '7,000万回突破' },
  { label: '吉田いをん「指ペロ配布、ま？」TikTok総再生数', value: '3,000万回突破' },
  { label: 'インフルエンサー関連SNS総再生数', value: '累計1億回突破' },
];

export const jpPopWorks = [
  {
    title: 'timelesz',
    description: '提供作品「オーシャンビュー」収録アルバムが日本レコード協会プラチナ認定。',
  },
  {
    title: 'THE JET BOY BANGERZ',
    description: '「Dancing In The Rain」がオリコン週間シングルランキング1位獲得。',
  },
  {
    title: 'M!LK',
    description: 'MUSIC AWARDS JAPAN 2026 最優秀ボーイズアイドルカルチャーアーティスト賞受賞アーティストへの作詞提供を担当。',
  },
  {
    title: 'Kep1er',
    description: '「ТІРІ-ТАР (Japanese ver.)」が韓国主要音楽チャート1位、米Billboardメインチャート最高14位を記録。',
  },
  {
    title: 'IVE',
    description: '「REBEL HEART -Japanese ver.-」「ATTITUDE -Japanese ver.-」が韓国主要音楽チャート1位獲得、日本レコード協会ゴールド認定。',
  },
];

export const influencerWorks = [
  {
    name: '総フォロワー700万人超え「Mumeixxx」',
    description: '作詞提供を行う',
  },
  {
    name: '総フォロワー200万人超え「吉田いをん」',
    description: '作詞・作曲・バックコーラス・ボーカルディレクション・マネジメント・ディレクター業務など、楽曲制作全般を担当',
  },
];